<template>
 <div class="drawer p-50 rounded-pill">
    <div class="d-flex justify-content-center align-items-center">
        <div>
            <div
                @click="$route.path.includes('/v2') ? $router.push({name: 'v2_pages_profile'}) : $router.push({name: 'v1_pages_profile'})"
                class="d-flex align-items-center dropdown-user-link text-decoration-none cursor-pointer"
            >
            <b-avatar
                size="40"
                :src="require('@/assets/images/avatars/AvatarImage.png')"
                variant="light-primary"
                badge
                class="badge-minimal mr-50"
                badge-variant="success"
            >
                <!-- <feather-icon
                    v-if="!userData.fullName"
                    icon="UserIcon"
                    size="22"
                /> -->
            </b-avatar>
            </div>
        </div>
        <div>
            <span class="mx-50 cursor-pointer">
                <img src="../../../../assets/images/skeleton/vr.png" alt="">
            </span>
        </div>
        <div>
            <span class="mx-50 cursor-pointer" @click="$route.path.includes('/v2') ? $router.push({name: 'v2_admin_dashboard'}) : $router.push({name: 'v1_admin_dashboard'})">
                <img src="../../../../assets/images/skeleton/admin_panel.png" alt="">
            </span>
        </div>
        <div>
            <span class="mx-50 cursor-pointer">
                <img src="../../../../assets/images/skeleton/settings.png" alt="">
            </span>
        </div>
        <div>
            <span class="mx-50 cursor-pointer" @click="logout()">
                <img src="../../../../assets/images/skeleton/logout.png" alt="">
            </span>
        </div>
    </div>
 </div> 
</template>

<script>
import { BCard, BCardBody, BAvatar, BNavItemDropdown, BDropdownItem, BDropdownDivider, } from 'bootstrap-vue'
import { avatarText } from '@core/utils/filter'
import { Auth, removeAuth, deleteToken, removeToken, resetPermission, setLogged, setToken } from '@/utils/auth';
import useJwt from '@/auth/jwt/useJwt'
export default {
    name:'Drawer',
    components: {
        BCard,
        BCardBody,
        BAvatar,
        BNavItemDropdown, 
        BDropdownItem, 
        BDropdownDivider,
    },
    data() {
        return {
            userData: JSON.parse(localStorage.getItem('userData')),
            avatarText,
        }
    },
    methods:{
        logout() {
            localStorage.removeItem(useJwt.jwtConfig.storageTokenKeyName)
            localStorage.removeItem(useJwt.jwtConfig.storageRefreshTokenKeyName)

            // Remove userData from localStorage
            localStorage.removeItem('userData')


            localStorage.clear();
            sessionStorage.clear();
            

            removeAuth()
            // this.$store.dispatch('users/logout');
            this.$router.push({ name: 'login' });
        }
    }
}
</script>

<style scoped>
.drawer {
  border-top: 3px solid rgba(255, 255, 255, 0.1);
  border-bottom: 2px solid rgba(255, 255, 255, 0.1);
  border-left: none;
  border-right: none;
  border-radius: 0; /* remove pill shape if not needed */
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  padding: 1rem;
  background-color: #A1A6AA; 

  /* Animation */
  /* animation: slideUpFade 1s ease-out forwards; */
}

.drawer{
  background-color: rgba(161, 166, 170, 0.3); 
  backdrop-filter: blur(30px);
  -webkit-backdrop-filter: blur(20px); /* Safari support */
  animation: slideUpFade 1s ease-out forwards;
}

@keyframes slideUpFade {
  from {
    transform: translateY(40px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

</style>